<template>
  <v-flex>
    <template v-if="this.loading != true">
      <v-card>
        <v-toolbar color="white">
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn @click="$refs.pdfComponent.print()">
              <v-icon>mdi-printer</v-icon>PRINT
            </v-btn>
            <v-btn @click="download()">
              <v-icon class="mr-2">mdi-cloud-download</v-icon>Download
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="currentPage = currentPage - 1" :disabled="currentPage == 1">Page précédente</v-btn>
            {{ currentPage }} / {{ pageCount }}
            <v-btn text @click="currentPage = currentPage + 1" :disabled="currentPage == pageCount">Page suivante</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <PDFView
          ref="pdfComponent"
          :src="pdf"
          @num-pages="pageCount = $event"
          :page="currentPage"
          style="width:100%"
        ></PDFView>
      </v-card>
    </template>
    <v-container v-else>
      <v-layout>
        <v-flex>Loading : Generating PDF</v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
import pdf from "vue-pdf";
export default {
  components: {
    PDFView : pdf
  },
  data() {
    return {
      loading: false,
      src: null,
      currentPage: 1,
      pageCount: 0,
      pdf: null
    };
  },
  props: {
    url: { type: String },
    params: { type: Object },
    filename: { type: String }
  },
  watch: {
    params () {
      this.getPdf()
    }
  },
  mounted: function() {
    this.getPdf();
  },
  methods: {
    getPdf: function() {
      this.loading = true;
      this.$store
        .dispatch(this.url, this.params)
        .then(data => {
          this.src = data;
          this.pdf = "data:application/pdf;base64," + data;
        })
        .finally(() => (this.loading = false));
    },
    download: function() {
      const binary = atob(this.src.replace(/\s/g, ""));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);
      for (var i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }

      // create the blob object with content-type "application/pdf"
      const blob = new Blob([view], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>

<style></style>
